export const etfHoldingsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "etf-holdings-widget" */ './module-entry'),
  cacheKey: 'etf-holdings-widget',
}
